import { useParams } from 'react-router-dom';
import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect, useRef } from 'react';
import { TableBox, ButtonBasic, DropDownSelector, ButtonClose, Tabs } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import useGeneralStore from '../../store/general';
import { useLocation } from 'react-router-dom';
import './ViewСompetitors.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { options_prop_mp } from '../../common/globalVariables';
import { FilterArticles } from '../../components/FilterArticles/FilterArticles';
import { ModalСonfirmation } from './ModalСonfirmation/ModalСonfirmation'
import { usePushNotifications } from '../../common/pushNotification';
import { ModalAddMpSimple } from './ModalAddMpSimple/ModalAddMpSimple';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  {
    label: 'Добавить конкурентов',
    value: 'add_competitors',
  },
  {
    label: 'Список конкурентов',
    value: 'list_of_competitors',
  },
  {
    label: 'Анализ',
    value: 'analysis'
  }
];

const ViewСompetitors = ({ }) => {

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'view-competitors');
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  const location = useLocation();

  // Рефы
  const fileInputRef = useRef(null);
  const activeTab = useParams()['*']

  // Обработка ошибок
  const { addErrorPush, addSuccessPush, addWarningPush } = usePushNotifications();

  // Конфигурация фильтров для URL параметров
  const filterConfig = [
    { key: 'mp', type: 'single' },
    { key: 'api', type: 'single' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' }
  ];

  const requestControllerRef = useRef(new RequestController());
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);

  const [pageValue, setPageValue] = useState(btn_tab[0]?.value);

  // Состояния для пагинации
  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [offerIdPage, setOfferIdPage] = useState(1);

  // Состояния для поисковых запросов
  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  // Данные для фильтров
  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  // Выбранные значения фильтров
  const [selectedMp, setSelectedMp] = useState({ label: 'Ozon', value: 1 });
  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  // Флаг для отслеживания первой инициализации из URL
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  // Фильтры 
  const [filterValue, setFilterValue] = useState([]);
  const [isModalFilter, setIsModalFilter] = useState(false);

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setCustomHeaders } = setTableFuncs;

  const [currentCompetitor, setCurrentCompetitor] = useState(null)

  const [isModalAddMpSimple, setIsModalMpSimple] = useState(false);
  const [isModalConfirmation, setIsModalConfirmation] = useState(false)
  const [selectedFile, setSelectedFile] = useState(false)
  const [loadingUpload, setLoadingUpload] = useState(false)

  // Инициализация фильтров из URL параметров при первом рендере
  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMp(urlParams.mp);
        if (urlParams.api) setSelectedApi(urlParams.api);
        if (urlParams.category) setSelectedCategory(urlParams.category);
        if (urlParams.brand) setSelectedBrand(urlParams.brand);
        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  // Первая инициализация url
  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMp,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand
    })
  }, [isReady]);

  // Остальные функции фильтров остаются без изменений
  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalApi,
      page: apiPage,
      setApiData: setApiData,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMp,
      setTotal: setTotalApi,
      filter: 'api_id',
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      selectedCategory,
      set: setCategoryData,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
      selectedShop: selectedMp,
      setTotal: setTotalCategory,
      filter: 'category',
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedMp,
      set: setBrandData,
      setBrandData: (e) => setBrandData(e),
      setTotal: setTotalBrand,
      filter: 'brand',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, brandPage, brandQuery]);

  useEffect(() => {
    return () => {
      requestControllerRef.current.abortAll();
    };
  }, []);

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Обработчик сброса фильтров
  const handleResetFilters = () => {
    setSelectedApi([]);
    setSelectedCategory([]);
    setSelectedBrand([]);
    updateURL({
      mp: null,
      api: null,
      category: null,
      brand: null
    });
    setIsTableRequest(!isTableRequest);
    setIsFilterRequest(!isFilterRequest)
    resetTable();
  };

  // Таблица товаров для ИИ анализа
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!selectedApi?.value) {
      resetTable()
      return
    }

    let sort;
    let filtersParam = [];

    if (params) {
      [sort, filtersParam] = params;
    }

    // Устанавливаем loading в true только если запрос не прерван
    if (!abortController.signal.aborted) {
      setLoading(true);
    }

    let url = `https://appche1.ecomru.ru:4348/api/products/mp${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam,
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      offer_id_list: filterValue,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  // Запись значений
  const fetchSetLinks = (apiId, mpId, offerId, newPrice, setStatus) => {
    let url = 'https://apps1.ecomru.ru:4655/v1/product-competitor/urls'

    const body = JSON.stringify({
      mp_id: mpId,
      api_id: apiId,
      offer_id: offerId,
      competitor_url: newPrice
    });

    fetch(url, { body, method: 'POST', headers })
      .then((res) => {
        if (res.ok) {
          setStatus('success')
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => { })
      .catch((err) => {
        setStatus('error');
        console.error(err);
      });
  };

  // Скачать шаблон цен
  const fetchGetTemplate = async () => {
    const url = `https://apps1.ecomru.ru:4655/v1/product-competitor/urls/excel-template`;

    try {
      // 1. Получаем JSON с URL файла
      const response = await fetch(url, { method: 'GET', headers });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
      }

      const json = await response.json();
      if (!json?.url) throw new Error("URL файла не найден в ответе");

      // 2. Создаём скрытую ссылку и скачиваем файл
      const link = document.createElement('a');
      link.href = json.url;
      link.download = 'price_template.xlsx'; // Имя файла
      link.style.display = 'none'; // Скрываем ссылку
      document.body.appendChild(link);
      link.click(); // Автоматический клик

      // 3. Очищаем ссылку через небольшой таймаут
      setTimeout(() => {
        document.body.removeChild(link);
      }, 100);
    } catch (err) {
      console.error('Ошибка:', err);
    }
  }

  // Загрузить шаблон
  const onUploadFileToLinks = (file, status) => {
    if (!file) {
      return;
    }

    setLoadingUpload(true)
    addWarningPush('Дождитесь окончания загрузки, после завершения процесса  появится уведомление')
    const url = `https://apps1.ecomru.ru:4655/v1/product-competitor/urls/by-excel?mp_id=${selectedMp?.value}&api_id=${selectedApi?.value}&replace_old=${status}`;

    const formData = new FormData();
    formData.append('file', file);

    const updatedHeaders = { ...headers };
    delete updatedHeaders['Content-Type'];

    fetch(url, {
      method: 'POST',
      updatedHeaders,
      headers: updatedHeaders,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json(); // сначала парсим ответ
        if (!res.ok) {
          const errorMessage = data.detail;
          addErrorPush(`Ошибка загрузки: ${errorMessage}`)
          throw new Error(`Upload failed: ${res.statusText}`);
        }
        return data;
      })
      .then((data) => {
        addSuccessPush('Ссылки загружены', 20000);
        if (fileInputRef.current) fileInputRef.current.value = ''
        setIsTableRequest(!isTableRequest)
      })
      .catch((err) => {
        console.error(err);
        if (fileInputRef.current) fileInputRef.current.value = ''
      })
      .finally(() => {
        setLoadingUpload(false)
        setSelectedFile(null)
      })
  };

  // Изменение статуса задачи задачи
  const fetchChangeStatus = (status, id) => {
    let url = `https://apps1.ecomru.ru:4655/v1/product-competitor/urls/active-status`

    const body = JSON.stringify({
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: id,
      active: !status
    })

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => setTimeout(() => fetchTableData(), 500))
      .catch(handleRequestError);
  }

  // Очистить ссылки
  const fetchClearLinks = (id) => {
    let url = `https://apps1.ecomru.ru:4655/v1/product-competitor/urls`

    const body = JSON.stringify({
      mp_id: selectedMp?.value,
      api_id: selectedApi?.value,
      offer_id: id
    })

    fetch(url, { method: 'DELETE', headers, body })
      .then(handleTableResponse)
      .then((json) => setTimeout(() => setIsTableRequest(!isTableRequest), 500))
      .catch((err) => handleRequestError);
  };

  const handleInput = (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = inputEvent?.id;
    const apiId = selectedApi?.value;
    const mpId = selectedMp?.value;
    let newPrice = inputEvent?.value;

    if (newPrice) {
      setStatus('loading');
      fetchSetLinks(apiId, mpId, offerId, newPrice, setStatus);
    } else {
      setStatus('error');
    }
  };

  const handleFileChangeTime = async (e) => {
    setIsModalConfirmation(true)
    setSelectedFile(e.target.files[0])
  };

  useEffect(() => {
    setPageValue(activeTab)
  }, [activeTab])

  useEffect(() => {
    const abortController = new AbortController();
    fetchTableData([], abortController)
    return () => abortController.abort();
  }, [isTableRequest, filterValue]);

  const onAction = (e) => {
    setCurrentCompetitor(e)
    setIsModalMpSimple(true)
  }

  useEffect(() => {
    if (!isModalAddMpSimple) {
      setTimeout(() => fetchTableData([]), 0)
    }
  }, [isModalAddMpSimple]);

  const contextMenuArr = [
    {
      label: 'Информация',
      onClick: (e) => {
        setCurrentCompetitor(e)
        setIsModalMpSimple(true)
      }
    },
    {
      label: 'Очистить',
      onClick: (e) => {
        fetchClearLinks(e?.offer_id, e?.row_id)
      }
    }
  ];

  const handleToggle = (data) => {
    fetchChangeStatus(data?.['Активна']?.[0], data?.['Активна']?.[1]);
  };

  return (
    <>
      {isModalAddMpSimple && (
        <ModalAddMpSimple
          selectedApi={selectedApi}
          selectedMp={selectedMp}
          currentCompetitor={currentCompetitor}
          setCurrentCompetitor={setCurrentCompetitor}
          setIsModal={(e) => setIsModalMpSimple(e)}
          fetchChangeStatus={fetchChangeStatus}
        />
      )}

      {isModalConfirmation && <ModalСonfirmation
        setIsModal={setIsModalConfirmation}
        onUploadFile={onUploadFileToLinks}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
      />}

      <div className="view-competitors">
        <TitlePage
          title='Конкуренты'
        />
        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
          onReset={handleResetFilters}
        >
          <DropDownSelector
            options_prop={options_prop_mp}
            state={selectedMp}
            total={options_prop_mp?.length}
            setState={(e) => setSelectedMp(e)}
            placeholder="Площадка"
            onBlur={() => {
              updateURL({ mp: selectedMp });
              filtersApi()
              filtersCategory();
              filtersBrand();
            }}
          />

          <DropDownSelector
            options_prop={apiData}
            state={selectedApi}
            setState={setSelectedApi}
            placeholder="Магазин"
            total={totalApi}
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            onBlur={(e) => {
              updateURL({ api: selectedApi });
              filtersCategory();
              filtersBrand();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            multi={true}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            onBlur={(e) => {
              updateURL({ category: selectedCategory });
              filtersBrand();
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            multi={true}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={(e) => {
              updateURL({ brand: selectedBrand });
              setIsTableRequest(!isTableRequest)
            }}
          />
        </FilterContainer>

        <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
          query={location?.search}
        />

        {pageValue === 'add_competitors' && <TableBox
          {...tableProps}
          paginator={true}
          ref={paginatorRef}
          fetchCallback={fetchTableData}
          onAction={onAction}
          onInputAction={handleInput}
          contextMenuArr={contextMenuArr}
          onToggle={(e) => handleToggle(e)}
          child={
            <>
              <ButtonBasic
                blue
                text='Шаблон загрузки Excel'
                size='32px'
                onClick={fetchGetTemplate}
              />

              <div className='view-competitors__btn-upload'>
                <ButtonBasic
                  green
                  text='Загрузить'
                  size='32px'
                  loading={loadingUpload}
                  disabled={!selectedApi?.value || !selectedMp?.value}
                />

                <input
                  type="file"
                  id="fileInput"
                  onChange={handleFileChangeTime}
                  ref={fileInputRef}
                  disabled={!selectedApi?.value || !selectedMp?.value}
                />
              </div>

              {/* <FilterArticles
                filterValue={filterValue}
                setFilterValue={setFilterValue}
              /> */}
            </>

          }
        />}
      </div>
    </>
  );
};

export { ViewСompetitors };
